import * as React           from 'react'
import { FormattedMessage } from 'react-intl'

import Button                              from '@material-ui/core/Button/Button'
import Grid                                from '@material-ui/core/Grid'
import Typography                          from '@material-ui/core/Typography'
import { FieldArray, InjectedFormikProps } from 'formik'

import { Study as TStudy }                 from '../../../api'
import withToggle, { InjectedToggleProps } from '../../hocs/withToggle'
import StudyCard                           from '../../molecules/StudyCard'
import { i18nErrorCodes }                  from '../form-utils'
import AddStudyDialog                      from '../StudyAddDialog'

type Props = InjectedFormikProps<InjectedToggleProps, { coachingStudies: TStudy [] }>

const ExperiencesChunk = ({
  errors,
  activate,
  deactivate,
  isActive,
  values:
    {
      coachingStudies,
    },
}: Props) => {
  const phrasing = {
    coachingStudies: <FormattedMessage id={'project.coachingStudies'} />,
    add:             <FormattedMessage id={'buttonActions.add'} />,
  }

  return (
    <FieldArray
      name={'coachingStudies'}
      render={({
        push,
        remove,
      }) => (
        <Grid
          container
          direction={'column'}
          spacing={16}
        >
          <Grid item>
            <Grid
              container
              justify={'space-between'}
            >
              <Grid item>
                <Typography variant={'subheading'}>
                  {phrasing.coachingStudies}
                </Typography>
              </Grid>
              <Grid>
                <Button onClick={activate} color={'secondary'}>
                  {phrasing.add}
                </Button>
              </Grid>
            </Grid>
          </Grid>

          {coachingStudies.map((study, i) => (
            <Grid item key={i}>
              <StudyCard
                onRemove={() => remove(i)}
                study={study}
              />
            </Grid>
          ))}

          {errors.coachingStudies && (
            <Grid item>
              <Typography variant={'subheading'} color={'error'}>
                <FormattedMessage id={'validation.' + i18nErrorCodes.minOneExperienceRequired} />
              </Typography>
            </Grid>
          )}

          <AddStudyDialog
            isOpen={isActive}
            close={deactivate}
            onClose={deactivate}
            onSubmit={values => {
              deactivate()
              push(values)
            }}
          />
        </Grid>
      )}
    />
  )
}

export default withToggle(ExperiencesChunk)



// WEBPACK FOOTER //
// ./src/components/forms/chunks/CoachingStudiesChunk.tsx